export const PASSWORD = 'password';
export const EMAIL = 'email';
export const PHONE_NUMBER = 'phoneNumber';
export const DATE = 'date';
export const MEASUREMENT_NUMBER = 'measurement-number';
